import React from 'react';
import { Form, Row, Col, Badge } from 'react-bootstrap';

const ROLE_OPTIONS = [
  { value: 'everyone', label: 'Jeder' },
  { value: 'followers', label: 'Follower' },
  { value: 'subscribers', label: 'Subscriber' },
  { value: 'vip', label: 'VIP' },
  { value: 'moderators', label: 'Moderatoren' },
  { value: 'broadcaster', label: 'Nur Broadcaster' },
];

const COMMANDS = [
  { key: 'sr', label: 'Song Request', cmdField: 'sr_command', description: 'Songs zur Queue hinzufügen' },
  { key: 'song', label: 'Aktueller Song', cmdField: 'currentsong_command', description: 'Zeigt den aktuellen Song' },
  { key: 'queue', label: 'Queue', cmdField: 'queue_command', description: 'Zeigt die Song-Queue' },
  { key: 'voteskip', label: 'Vote Skip', cmdField: 'voteskip_command', description: 'Per Abstimmung skippen' },
  { key: 'volume', label: 'Lautstärke', cmdField: 'volume_command', description: 'Spotify Lautstärke ändern', aliases: '!vol' },
  { key: 'play', label: 'Play', cmdField: 'play_command', description: 'Wiedergabe fortsetzen' },
  { key: 'stop', label: 'Stop / Pause', cmdField: 'stop_command', description: 'Wiedergabe pausieren', aliases: '!pause' },
  { key: 'skip', label: 'Skip', cmdField: 'skip_command', description: 'Song sofort skippen' },
];

export default function CommandEditor({ settings, onChange }) {
  if (!settings) return null;

  const cmdConfig = settings.command_config || {};

  const updateCmdConfig = (cmdKey, field, value) => {
    const current = cmdConfig[cmdKey] || { enabled: true, allowed_for: 'everyone' };
    onChange({
      command_config: {
        ...cmdConfig,
        [cmdKey]: { ...current, [field]: value },
      },
    });
  };

  const responseField = (label, key) => (
    <Form.Group className="mb-2" key={key}>
      <Form.Label className="text-muted small mb-1">{label}</Form.Label>
      <Form.Control
        size="sm"
        value={(settings.responses || {})[key] || ''}
        onChange={(e) =>
          onChange({ responses: { ...(settings.responses || {}), [key]: e.target.value } })
        }
        className="bg-dark text-white border-secondary"
      />
    </Form.Group>
  );

  return (
    <div>
      <h6 className="text-secondary mb-3">Commands</h6>
      <p className="text-muted small mb-3">
        Der Broadcaster kann alle Commands immer verwenden, unabhängig von den Einstellungen.
      </p>

      {COMMANDS.map((cmd) => {
        const cfg = cmdConfig[cmd.key] || { enabled: true, allowed_for: 'everyone' };
        const isEnabled = cfg.enabled !== false;

        return (
          <div
            key={cmd.key}
            className="mb-3 p-2 rounded"
            style={{
              backgroundColor: isEnabled ? 'rgba(255,255,255,0.03)' : 'rgba(255,255,255,0.01)',
              border: '1px solid var(--bs-border-color)',
              opacity: isEnabled ? 1 : 0.6,
            }}
          >
            <Row className="align-items-center g-2">
              <Col xs={12} sm={4} className="d-flex align-items-center gap-2">
                <Form.Check
                  type="switch"
                  checked={isEnabled}
                  onChange={(e) => updateCmdConfig(cmd.key, 'enabled', e.target.checked)}
                  className="me-1"
                />
                <div>
                  <strong className="text-white small">{cmd.label}</strong>
                  {cmd.aliases && (
                    <Badge bg="secondary" className="ms-1" style={{ fontSize: '0.65rem' }}>
                      {cmd.aliases}
                    </Badge>
                  )}
                  <div className="text-muted" style={{ fontSize: '0.7rem' }}>{cmd.description}</div>
                </div>
              </Col>
              <Col xs={6} sm={4}>
                <Form.Control
                  size="sm"
                  value={settings[cmd.cmdField] || ''}
                  onChange={(e) => onChange({ [cmd.cmdField]: e.target.value })}
                  className="bg-dark text-white border-secondary"
                  disabled={!isEnabled}
                  placeholder="Command"
                />
              </Col>
              <Col xs={6} sm={4}>
                <Form.Select
                  size="sm"
                  value={cfg.allowed_for || 'everyone'}
                  onChange={(e) => updateCmdConfig(cmd.key, 'allowed_for', e.target.value)}
                  className="bg-dark text-white border-secondary"
                  disabled={!isEnabled}
                >
                  {ROLE_OPTIONS.map((r) => (
                    <option key={r.value} value={r.value}>
                      {r.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          </div>
        );
      })}

      <h6 className="text-secondary mt-4 mb-3">Bot-Antworten</h6>
      <p className="text-muted small">
        Platzhalter: <code>{'{title}'}</code>, <code>{'{artist}'}</code>, <code>{'{requester}'}</code>,{' '}
        <code>{'{current}'}</code>, <code>{'{needed}'}</code>, <code>{'{volume}'}</code>
      </p>
      {responseField('SR erfolgreich', 'sr_success')}
      {responseField('SR bereits in Queue', 'sr_already_queued')}
      {responseField('SR nicht gefunden', 'sr_not_found')}
      {responseField('SR deaktiviert', 'sr_disabled')}
      {responseField('Aktueller Song', 'currentsong')}
      {responseField('Kein Song läuft', 'currentsong_none')}
      {responseField('Queue', 'queue_list')}
      {responseField('Queue leer', 'queue_empty')}
      {responseField('Vote Skip hinzugefügt', 'voteskip_added')}
      {responseField('Song geskippt (voteskip)', 'voteskip_skipped')}
      {responseField('Bereits gevotet', 'voteskip_already')}
      {responseField('Lautstärke geändert', 'volume_changed')}
      {responseField('Wiedergabe fortgesetzt', 'play_resumed')}
      {responseField('Wiedergabe pausiert', 'playback_stopped')}
      {responseField('Song geskippt (skip)', 'track_skipped')}
    </div>
  );
}
